import React from 'react'

import { UpsellProvider, useUpsell } from 'modules/upselling_kit/lib/upsellContext'
import { UpsellingKitModule } from 'modules/upselling_kit/types'

type BaseProps = {
  children?: React.ReactNode
  loadingComponent?: React.ReactNode
  fallbackComponent?: React.ReactNode
}
type Props = UpsellingKitModule & BaseProps

const GuardUpsellComponent = ({ children, loadingComponent, fallbackComponent }: BaseProps) => {
  const { isAllowed, loading, isAlreadyInstalled, isFeatureAlreadyAvailable, moduleAvailable } =
    useUpsell()

  if (loading) {
    return loadingComponent
  }

  if (!moduleAvailable) {
    return fallbackComponent
  }

  const shouldShowUpselling = isAllowed && (!isAlreadyInstalled || !isFeatureAlreadyAvailable)

  return shouldShowUpselling ? children : fallbackComponent
}

export const UpsellGuard = ({
  children,
  loadingComponent,
  moduleRequested,
  requestSource,
  requestReason,
  featureRequested,
  fallbackComponent,
}: Props) => {
  return (
    <UpsellProvider
      moduleRequested={moduleRequested}
      requestSource={requestSource}
      requestReason={requestReason}
      featureRequested={featureRequested}
    >
      <GuardUpsellComponent
        loadingComponent={loadingComponent}
        fallbackComponent={fallbackComponent}
      >
        {children}
      </GuardUpsellComponent>
    </UpsellProvider>
  )
}
